import receptionist from "@/views/queues/receptionist.vue";
import nursing from "@/views/queues/nursing/index.vue";
import doctor from "@/views/queues/doctor.vue";
import identification from "@/views/queues/nursing/identification.vue";
import pre_exam from "@/views/queues/nursing/pre_exam.vue";
import Therapy from "@/views/queues/nursing/therapy.vue";
import Attendances from "@/views/queues/nursing/attendances.vue";
import Authorization from "@/views/queues/authorization/index.vue";
import Planning from "@/views/queues/surgical_planning/index.vue";

import IdentificationExams from "@/views/queues/exam/identification.vue";
import Exam from "@/views/queues/exam/index.vue";
import WaitingExams from "@/views/queues/exam/waiting.vue";
import ExecutingExams from "@/views/queues/exam/executing.vue";
import TherapyExams from "@/views/queues/exam/therapy.vue";

import ContactLensTest from "@/views/queues/contact_lens_test.vue";

import SurgicalWard from "@/views/queues/surgical_ward/index.vue";
import SurgicalWardReception from "@/views/queues/surgical_ward/reception.vue";
import SurgicalWardPreoperative from "@/views/queues/surgical_ward/preoperative.vue";
import SurgicalWardIntraoperative from "@/views/queues/surgical_ward/intraoperative.vue";
import SurgicalWardPostoperative from "@/views/queues/surgical_ward/postoperative.vue";

import DefaultLayout from "@/views/layouts/default.vue";
import Patients from "@/views/patients/index.vue";

export default [
  {
    path: "/filas",
    name: "Filas",
    component: DefaultLayout,
    redirect: {
      name: "Fila da recepção",
    },
    children: [
      {
        path: "/pacientes",
        name: "Pacientes",
        component: Patients,
      },
      {
        path: "recepcao",
        name: "Fila da recepção",
        component: receptionist,
      },
      {
        path: "medico",
        name: "Fila do medico",
        component: doctor,
      },
      {
        path: "enfermagem/:attendancePlaceId",
        name: "Fila da enfermagem",
        component: nursing,
        props: true,
        redirect: {
          name: "Fila de identificação",
        },
        children: [
          {
            path: "identificacao",
            name: "Fila de identificação",
            component: identification,
          },
          {
            path: "pre-exames",
            name: "Fila de Pré Exames",
            component: pre_exam,
          },
          {
            path: "terapeutica",
            name: "Fila de Terapêuticas",
            component: Therapy,
          },
          {
            path: "consultas",
            name: "Fila de Consultas",
            component: Attendances,
          },
        ],
      },
      {
        path: "autorizacao",
        name: "Fila de Authorização",
        component: Authorization,
      },
      {
        path: "planejamento-cirurgico",
        name: "Fila de Planejamento Cirurgico",
        component: Planning,
      },
      {
        path: "exames/:attendancePlaceId",
        name: "Fila de exames",
        component: Exam,
        props: true,
        redirect: {
          name: "Identificação de exames",
        },
        children: [
          {
            path: "identificacao",
            name: "Identificação de exames",
            component: IdentificationExams,
          },
          {
            path: "aguardando",
            name: "Aguardando Exames",
            component: WaitingExams,
          },
          {
            path: "dilatacao",
            name: "Fila de Dilatação",
            component: TherapyExams,
          },
          {
            path: "executando",
            name: "Fila de Execução",
            component: ExecutingExams,
          },
        ],
      },
      {
        path: "lente-contato",
        name: "Fila de teste de lente",
        component: ContactLensTest,
      },
      {
        path: "bloco-cirurgico",
        name: "Bloco cirúrgico",
        component: SurgicalWard,
        redirect: {
          name: "Fila de recepção",
        },
        children: [
          {
            path: "recepcao",
            name: "Fila de recepção",
            component: SurgicalWardReception,
          },
          {
            path: "pre-operatorio",
            name: "Fila de Pré-operatório",
            component: SurgicalWardPreoperative,
          },
          {
            path: "intra-operatorio",
            name: "Fila de Intra-operatório",
            component: SurgicalWardIntraoperative,
          },
          {
            path: "pos-operatorio",
            name: "Fila de Pós-operatório",
            component: SurgicalWardPostoperative,
          },
        ],
      },
    ],
  },
];
